// Simple in-memory cache for auth session
let sessionCache: {
  session: any;
  timestamp: number;
} | null = null;

const SESSION_CACHE_DURATION = 1000 * 60 * 5; // 5 minutes

export const getCachedSession = () => {
  if (
    sessionCache &&
    Date.now() - sessionCache.timestamp < SESSION_CACHE_DURATION
  ) {
    return sessionCache.session;
  }
  return null;
};

export const setCachedSession = (session: any) => {
  sessionCache = {
    session,
    timestamp: Date.now(),
  };
};

export const clearSessionCache = () => {
  sessionCache = null;
};